import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionModel } from 'src/app/models/api/permission.model';
import { PermissionsEnum } from 'src/app/constants/settings.enum';
import { PermissionsService } from '../../permissions.service';
@Component({
    selector: 'app-permissioned-switch',
    templateUrl: './permissioned-switch.component.html'
})
export class PermissionedSwitchComponent implements OnInit, OnDestroy {
    @Input() forPermission!: PermissionsEnum | string;
    @Input() givenId: string = "SwitchieMc Switchie";
    @Input() myValue: boolean = false;
    /**
     * Whether this Permissioned Switch is also About its own Value
     */
    @Input() forItself: boolean = false;
    @Output() valueSwitched: EventEmitter<boolean> = new EventEmitter<boolean>();
    permission: PermissionModel = new PermissionModel();
    permissionsUpdatedSubscription: Subscription;
    selectedOrganisationId: string = "";
    /** ANY config disables the switching, first change the locking */
    get valueShouldBeDisabled(): boolean {
        if(this.forItself){
            return !this.permission || (this.permission.isLocked || this.permission.isDisabled || this.permission.isHidden);
        }
        return !this.permission || !this.permission.value || this.permission.value.toLowerCase() != "true";
    }
    constructor(private permissionsService: PermissionsService) {
        this.permissionsUpdatedSubscription = this.permissionsService.permissionsUpdated.subscribe(unneededValue => {
            this.getPermission();
        });
    }
    ngOnInit(): void {
        this.getPermission();
    }
    getPermission() {
        this.permission = this.permissionsService.GetPermission(this.forPermission);
        if (this.forItself) {
            this.myValue = this.permission.valueAsBoolean;
        }
    }
    emitValue(event: any) {
        let permissionElement: HTMLInputElement = (event.target as HTMLInputElement);
        this.valueSwitched.emit(permissionElement.checked);
    }
    ngOnDestroy() {
        if (this.permissionsUpdatedSubscription) {
            this.permissionsUpdatedSubscription.unsubscribe();
        }
    }
}